import React from 'react';
import { X, Trash2, Check, Loader2 } from 'lucide-react';

interface ComposerHeaderProps {
    isExisting: boolean;
    localTitle: string;
    setLocalTitle: (title: string) => void;
    onBlur: () => void;
    onClose: () => void;
    onDelete: () => void;
    onSave: () => void;
    isLoading: boolean;
}

/**
 * ComposerHeader: Pinned top-bar for the Event Composer.
 * Handles primary actions and title entry.
 * SHADOW VERSION (.tsx)
 */
export const ComposerHeader: React.FC<ComposerHeaderProps> = ({ 
    isExisting, 
    localTitle, 
    setLocalTitle, 
    onBlur, 
    onClose, 
    onDelete, 
    onSave, 
    isLoading 
}) => {
    return (
        <header style={{ 
            height: '54px', 
            borderBottom: '1px solid #222', 
            display: 'flex', 
            alignItems: 'center', 
            padding: '0 15px', 
            justifyContent: 'space-between', 
            backgroundColor: '#0a0a0a', 
            flexShrink: 0 
        }}>
            <button 
                onClick={onClose} 
                style={{ all: 'unset', cursor: 'pointer', padding: '5px' }}
                aria-label="Close"
            >
                <X size={24} color="#666" />
            </button>

            <div style={{ flex: 1, margin: '0 15px' }}>
                <input 
                    type="text" 
                    placeholder={isExisting ? "Edit Event..." : "New Event..."}
                    value={localTitle}
                    onChange={(e) => setLocalTitle(e.target.value)}
                    onBlur={onBlur}
                    style={{ 
                        all: 'unset', 
                        width: '100%', 
                        color: '#fff', 
                        fontSize: '14px', 
                        fontWeight: '900',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    }}
                />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {isExisting && (
                    <button 
                        onClick={() => { if(window.confirm('DELETE this event?')) onDelete(); }} 
                        style={{ all: 'unset', cursor: 'pointer', padding: '8px' }}
                        aria-label="Delete"
                    >
                        <Trash2 size={18} color="#ef4444" />
                    </button>
                )}
                <button 
                    onClick={onSave} 
                    disabled={isLoading} 
                    style={{ 
                        all: 'unset', 
                        cursor: 'pointer', 
                        padding: '5px', 
                        opacity: isLoading ? 0.5 : 1 
                    }}
                    aria-label="Save"
                >
                    {isLoading ? <Loader2 size={24} color="#f29b11" className="animate-spin" /> : <Check size={24} color="#2ecc71" />}
                </button>
            </div>
        </header>
    );
};
